import { z } from 'zod';
import { OfferRequestTimeConstraint } from './timeConstraint.js';
export const offerRequestTimingGroupSchema = z.enum([
    'emergency_now',
    'as_soon_as_possible',
    'within_4_weeks',
    'within_3_to_6_months',
    'within_12_months',
    'not_yet_defined',
]);
export const OfferRequestTimingGroup = offerRequestTimingGroupSchema.enum;
export const TIME_CONSTRAINTS_BY_TIMING_GROUP = {
    emergency_now: [OfferRequestTimeConstraint.IMMEDIATELY],
    as_soon_as_possible: [OfferRequestTimeConstraint.AS_SOON_AS_POSSIBLE],
    within_4_weeks: [
        OfferRequestTimeConstraint.WITHIN_2_WEEKS,
        OfferRequestTimeConstraint.WITHIN_30_DAYS,
        OfferRequestTimeConstraint.WITHIN_1_MONTH,
        OfferRequestTimeConstraint.ONE_WEEK,
        OfferRequestTimeConstraint.TWO_WEEKS,
        OfferRequestTimeConstraint.THREE_WEEKS,
        OfferRequestTimeConstraint.FOUR_WEEKS,
    ],
    within_3_to_6_months: [
        OfferRequestTimeConstraint.WITHIN_3_MONTHS,
        OfferRequestTimeConstraint.IN_3_TO_6_MONTHS,
        OfferRequestTimeConstraint.EARLIEST_IN_6_MONTHS,
        OfferRequestTimeConstraint.WITHIN_6_MONTHS,
    ],
    within_12_months: [
        OfferRequestTimeConstraint.WITHIN_9_MONTHS,
        OfferRequestTimeConstraint.WITHIN_12_MONTHS,
        OfferRequestTimeConstraint.LONGER_THAN_4_WEEKS,
        OfferRequestTimeConstraint.OVER_TWO_WEEKS,
    ],
    not_yet_defined: [OfferRequestTimeConstraint.BY_ARRANGEMENT, OfferRequestTimeConstraint.UNKNOWN],
};
const TIMING_GROUP_BY_TIME_CONSTRAINT = new Map(offerRequestTimingGroupSchema.options.flatMap((group) => TIME_CONSTRAINTS_BY_TIMING_GROUP[group].map((constraint) => [constraint, group])));
export function timingGroupForConstraint(constraint) {
    return TIMING_GROUP_BY_TIME_CONSTRAINT.get(constraint);
}
